export default ({ COLORS }) => ({
  warning: {
    color: COLORS.TEXT.MID_GREY.NORMAL
  }
})
